__webpack_require__.p = "https://live.pystatic.com/webassets/webview-promotions-section/promotions-section/3.7.0/_next/";